import styled from "styled-components";
import { ContentContainer } from "../../ui/display/ContentContainer";
import { useState } from "react";
import { Input } from "../../ui/inputs/Input";
import { Button } from "../../ui/controls/Button";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";


export const ProjectPath = ({path, onUpdate, onUpdateAdd, onRemove, children}) => {

    const [pathEdit, setPathEdit] = useState(null);
    const [newUpdateDescription, setNewUpdateDescription] = useState('');

    return (
        <StyledProjectPath padding='none' contentOrientation="column" contentGap="md">
            <div className="updatesGroupHeader">
                <div className="title">
                    <MaterialIcon
                        name='conversion_path'
                        weight={300}
                    />
                    {
                        !pathEdit ?
                        <div>
                            {path.pathName}
                        </div>
                        :
                        <input
                            value={pathEdit ? pathEdit : ''}
                            onChange={(e) => setPathEdit(e.target.value)}
                        />
                    }
                    
                </div>
                <div className="editContainer">
                    {
                        !pathEdit ? 
                        <>
                            <div className="expandOptionsIcon">
                                <MaterialIcon
                                    name='more_vert'
                                    size='sm'
                                    color={({theme}) => theme.colors.mutedForeground}
                                />
                            </div>
                            <div className="optionsContainer">
                                <MaterialIcon
                                    name="inventory_2"
                                    weight={300}
                                    size='sm'
                                    color={({theme}) => theme.colors.errorForeground}
                                    onClick={onRemove}
                                    
                                />
                                
                                <MaterialIcon
                                    name='edit'
                                    weight={300}
                                    size='sm'
                                    color={({theme}) => theme.colors.mutedForeground}
                                    onClick={() => setPathEdit(path.pathName)}
                                />
                                
                            </div>
                        </>
                        :
                        <MaterialIcon
                            name="check"
                            weight={300}
                            onClick={() => {
                                onUpdate?.(pathEdit);
                                setPathEdit(null)}
                            }
                        />
                    }
                    
                </div>
            </div>
            <div className="updatesGroupContent">
                {children}
            </div>
            <div className="updatesGroupFooter">
                <Input
                    style={{flex: 1}}
                    placeholder="Beskriv oppdateringen"
                    value={newUpdateDescription}
                    onChange={(e) => setNewUpdateDescription(e.target.value)}
                />
                <Button
                    text='Legg til'
                    onClick={() => {
                        if(newUpdateDescription.length < 5) return;
                        onUpdateAdd?.({
                            updatePath: path.pathUuid,
                            description: newUpdateDescription,
                            date: (new Date()).toISOString().slice(0, 10),
                            updateUuid: crypto.randomUUID()
                        });
                        setNewUpdateDescription('');
                    }}
                />
            </div>
        </StyledProjectPath>
    )
}

const StyledProjectPath = styled(ContentContainer)`
    div.updatesGroupHeader
    {
        background: ${({theme}) => theme.colors.neutralSecondaryBackground};
        border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        padding: ${({theme}) => theme.spacing.md} ${({theme}) => theme.spacing.lg};
        display: flex;
        align-items: center;
        justify-content: space-between;

        div.title
        {
            display: flex;
            align-items: center;
            gap: ${({theme}) => theme.spacing.md};
            
            > div
            {
                margin-left: ${({theme}) => theme.spacing.md};
                padding: ${({theme}) => theme.spacing.sm} 0;
                border: 1px solid transparent;
                font-weight: 600;
            }

            > input
            {
                border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
                background: ${({theme}) => theme.colors.neutralInputBackground};
                border-radius: ${({theme}) => theme.cornerRadius.md};
                padding: ${({theme}) => theme.spacing.sm} ${({theme}) => theme.spacing.md};
                font-size: ${({theme}) => theme.fontSize.md};
                outline: none;
                font-weight: 600;

                &:hover
                {
                    border: 1px solid ${({theme}) => theme.colors.mutedForeground};
                }

                &:focus
                {
                    border: 1px solid ${({theme}) => theme.colors.primaryForeground};
                }
            }
        }

        div.editContainer
        {
            display: flex;
            align-items: center;
            height: 24px;
            
            .icon
            {
                cursor: pointer;
            }
            
            div.expandOptionsIcon
            {
                transition-duration: 110ms;
                width: 24px;
                overflow: hidden;
            }

            div.optionsContainer
            {
                display: flex;
                gap: ${({theme}) => theme.spacing.sm};
                align-items: center;
                overflow: hidden;
                width: 0;
                transition-duration: 110ms;
            }

            &:hover
            {
                div.optionsContainer
                {
                    width: 53px;
                }

                div.expandOptionsIcon
                {
                    width: 0;
                    opacity: 0;
                }
            }
        }
    }

    div.updatesGroupContent
    {
        padding: ${({theme}) => theme.spacing.md};
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.md};
    }

    div.updatesGroupFooter
    {
        padding: ${({theme}) => theme.spacing.md} ${({theme}) => theme.spacing.lg};
        padding-left: calc(115px + ${({theme}) => theme.spacing.md});
        display: flex;
        gap: ${({theme}) => theme.spacing.md};

    }
`